export const AdminTabsActionTypes = {
  SET_ADMIN_TAB: '[ADMIN TABS] Set active tab'
};
